import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { ReactComponent as PathwayLogo } from "../../assets/images/logos/pathway-logo.svg";

import { Box } from "@mui/material";

export const Logo = styled((props) => {
    const { variant, padding, size, ...other } = props;
    const pad = padding ? padding : 3;
    const color = variant === "light" ? "#C1C4D6" : "#5048E5";
    const width = size ? size : "300px";
    return (
        <Box sx={{ p: pad, width: width, m: "auto" }}>
            <PathwayLogo />
        </Box>
    );
})``;

Logo.defaultProps = {
    variant: "primary",
};

Logo.propTypes = {
    variant: PropTypes.oneOf(["light", "primary"]),
};
